function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#E01E5A",
  d: "M17.032 50.451c0 4.58-3.742 8.323-8.322 8.323-4.581 0-8.323-3.742-8.323-8.323 0-4.58 3.742-8.322 8.323-8.322h8.322v8.322zm4.194 0c0-4.58 3.742-8.322 8.322-8.322 4.581 0 8.323 3.741 8.323 8.322V71.29c0 4.58-3.742 8.322-8.323 8.322-4.58 0-8.322-3.742-8.322-8.322V50.45z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#36C5F0",
  d: "M29.548 17.032c-4.58 0-8.322-3.742-8.322-8.322 0-4.581 3.742-8.323 8.322-8.323 4.581 0 8.323 3.742 8.323 8.323v8.322h-8.323zm0 4.194c4.581 0 8.323 3.742 8.323 8.322 0 4.581-3.742 8.323-8.323 8.323H8.71c-4.581 0-8.323-3.742-8.323-8.323 0-4.58 3.742-8.322 8.323-8.322h20.838z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2EB67D",
  d: "M62.967 29.548c0-4.58 3.742-8.322 8.323-8.322 4.58 0 8.322 3.742 8.322 8.322 0 4.581-3.742 8.323-8.322 8.323h-8.323v-8.323zm-4.193 0c0 4.581-3.742 8.323-8.323 8.323-4.58 0-8.322-3.742-8.322-8.323V8.71c0-4.581 3.741-8.323 8.322-8.323 4.58 0 8.323 3.742 8.323 8.323v20.838z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ECB22E",
  d: "M50.451 62.967c4.58 0 8.323 3.742 8.323 8.323 0 4.58-3.742 8.322-8.323 8.322-4.58 0-8.322-3.742-8.322-8.322v-8.323h8.322zm0-4.193c-4.58 0-8.322-3.742-8.322-8.323 0-4.58 3.741-8.322 8.322-8.322H71.29c4.58 0 8.322 3.741 8.322 8.322 0 4.58-3.742 8.323-8.322 8.323H50.45z"
}));

var SvgSlackIco = function SvgSlackIco(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSlackIco, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/slack_ico.ced70240.svg";
export { ForwardRef as ReactComponent };